import React from "react";
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from "@Utils/cn";

export const headingVariants = cva('font-semibold', {
  variants: {
    styleAs: {
      h1: 'text-4xl',
      h2: 'text-3xl',
      h3: 'text-2xl',
      h4: 'text-xl',
      h5: 'text-lg',
      h6: '',
      p: '',
      span: '',
    },
  },
  defaultVariants: {
    styleAs: 'h1',
  },
});

type HeadingLevel = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span';

type HeadingProps = React.ComponentProps<HeadingLevel> &
  VariantProps<typeof headingVariants> & {
    level?: HeadingLevel;
    styleAs?: HeadingLevel;
  };

const Heading = ({ children, className, level = 'h1', styleAs }: HeadingProps) => {
  const Comp = level;
  const realStyleAs = styleAs ?? level;

  return (
    <Comp className={cn(headingVariants({ styleAs: realStyleAs, className }))}>{children}</Comp>
  );
};

export default Heading;